module.exports = __webpack_public_path__ + "static/media/logos_50h_pacific.0f1c54f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_pacific.jpg
// module id = 222
// module chunks = 0